import { FormatIcu } from '@tolgee/format-icu';
// import { BackendFetch, DevTools, Tolgee } from '@tolgee/react';
import { DevTools, Tolgee } from '@tolgee/react';

import arAELocal from '../messages/ar-AE.json';
import arEGLocal from '../messages/ar-EG.json';
import arSALocal from '../messages/ar-SA.json';
import deDELocal from '../messages/de-DE.json';
import enAULocal from '../messages/en-AU.json';
import enCALocal from '../messages/en-CA.json';
import enGBLocal from '../messages/en-GB.json';
import enUSLocal from '../messages/en-US.json';
import esESLocal from '../messages/es-ES.json';
import esMXLocal from '../messages/es-MX.json';
import esUSLocal from '../messages/es-US.json';
import frFRLocal from '../messages/fr-FR.json';
import hiINLocal from '../messages/hi-IN.json';
import huHULocal from '../messages/hu-HU.json';
import idIDLocal from '../messages/id-ID.json';
import itITLocal from '../messages/it-IT.json';
import koKRLocal from '../messages/ko-KR.json';
import nbNOLocal from '../messages/nb-NO.json';
import ptBRLocal from '../messages/pt-BR.json';
import ukUALocal from '../messages/uk-UA.json';

export const localeOptions = [
  ['en-US', '🇺🇸 English'],
  ['en-GB', '🇬🇧 English'],
  ['en-CA', '🇨🇦 English'],
  ['en-AU', '🇦🇺 English'],
  ['es-ES', '🇪🇸 Español'],
  ['es-MX', '🇲🇽 Español'],
  ['es-US', '🇺🇸 Español'],
  // ['es-CO', '🇨🇴 Español'], // commented out options aren't fully translated
  // ['es-AR', '🇦🇷 Español'],
  ['ar-AE', '🇦🇪 العربية'],
  ['ar-EG', '🇪🇬 العربية'],
  ['ar-SA', '🇸🇦 العربية'],
  ['fr-FR', '🇫🇷 Français'],
  ['de-DE', '🇩🇪 Deutsch'],
  ['it-IT', '🇮🇹 Italiano'],
  ['pt-BR', '🇧🇷 Português'],
  // ['fa-IR', '🇮🇷 فارسی'],
  ['ko-KR', '🇰🇷 한국어'],
  ['hi-IN', '🇮🇳 हिंदी'],
  ['id-ID', '🇮🇩 Indonesia'],
  ['uk-UA', '🇺🇦 Українська'],
  // ['tr-TR', '🇹🇷 Türkçe'],
  ['nb-NO', '🇳🇴 Norsk'],
  ['hu-HU', '🇭🇺 Magyar'],
  // ['nl-NL', '🇳🇱 Nederlands'],
  // ['pl-PL', '🇵🇱 Polski'],
  // ['cs-CZ', '🇨🇿 Čeština'],
  // ['ro-RO', '🇷🇴 Română'],
  // ['sv-SE', '🇸🇪 Svenska'],
];

export const DefaultLocale = 'en-US';

export const tolgee = Tolgee()
  .use(DevTools())
  .use(FormatIcu())
  // .use(
  //   BackendFetch({
  //     prefix: 'https://cdn.tolg.ee/d1ad92d4126a048c398b314625ca450c',
  //   }),
  // )
  .init({
    defaultLanguage: DefaultLocale,
    // for dev mode
    apiUrl: process.env.NEXT_PUBLIC_TOLGEE_API_URL,
    apiKey: process.env.NEXT_PUBLIC_TOLGEE_API_KEY,
    availableLanguages: [...localeOptions.map(([value]) => value)],
    // for production and server
    staticData: {
      'en-US': enUSLocal,
      'en-GB': enGBLocal,
      'en-CA': enCALocal,
      'en-AU': enAULocal,
      'es-ES': esESLocal,
      'es-MX': esMXLocal,
      'es-US': esUSLocal,
      'ar-AE': arAELocal,
      'ar-EG': arEGLocal,
      'ar-SA': arSALocal,
      'fr-FR': frFRLocal,
      'de-DE': deDELocal,
      'it-IT': itITLocal,
      'pt-BR': ptBRLocal,
      'ko-KR': koKRLocal,
      'hi-IN': hiINLocal,
      'id-ID': idIDLocal,
      'uk-UA': ukUALocal,
      'nb-NO': nbNOLocal,
      'hu-HU': huHULocal,
    },
  });
